import Control from '../../common/Control';
import includes from 'lodash/includes';
import { connect } from 'react-redux';
import { selectListBlur, selectListChange } from './actions';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    checked: question && includes(question.values, ownProps.value),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(
      selectListChange(e.target.value, e.target.checked, ownProps.questionId)
    ),
  onBlur: () => dispatch(selectListBlur(ownProps.questionId)),
});

const SelectListControl = connect(mapStateToProps, mapDispatchToProps)(Control);

export default SelectListControl;
